// deps
import React, { memo, useCallback, useRef } from "react";

// internal deps
import { ElementObserver } from "@swiggy-private/core-ui";
import classNames from "classnames";

import styles from "../styles/PurchasePlan.v4.scss";

export interface OfferBadgeProps {
    text: string;
    impressionSuperOfferBadge?: (offerText: string) => void;
    testId?: string;
    isOneTapPlan?: boolean;
}

const OfferBadge: React.FC<OfferBadgeProps> = ({
    text,
    impressionSuperOfferBadge,
    testId,
    isOneTapPlan,
}: OfferBadgeProps) => {
    const isEventCaptured = useRef(false);

    const captureOfferBadgeImpression = useCallback(() => {
        if (isEventCaptured.current) {
            return;
        }
        impressionSuperOfferBadge?.(text);
        isEventCaptured.current = true;
    }, [text, impressionSuperOfferBadge]);

    const badgeContainerStyle = classNames({
        [styles.offerContainer]: !isOneTapPlan,
        [styles.offerContainerLeft]: isOneTapPlan,
    });

    const badgeStyle = classNames({
        [styles.offerBadge]: !isOneTapPlan,
        [styles.offerBadgeRoundedBottom]: isOneTapPlan,
    });

    return (
        <ElementObserver aria-hidden="true" className={badgeContainerStyle} onViewEnter={captureOfferBadgeImpression}>
            <span className={badgeStyle} data-testid={testId}>
                {text}
            </span>
        </ElementObserver>
    );
};

export default memo(OfferBadge);
